module.exports = __webpack_public_path__ + "public/images/about-netw-arrow.9561f5db388c01cbc89bb49b8c16d109.svg";